import React from 'react'
import classnames from 'classnames'
import { Add } from '@mui/icons-material'

const AddUnitHolder = ({ calendarType, onClick, isBFY = false }) => (
  <div className={classnames('unit-holder', 'unit-holder--add')}>
    <div className="unit-container unit-container--add">
      <button
        type="button"
        className={'unit unit--add ' + (isBFY ? 'unit-add--bfy' : '')}
        onClick={() => onClick(calendarType)}
      >
        <Add className="btn-point-events" />
        <h3>Add unit</h3>
      </button>
    </div>
  </div>
)

export default AddUnitHolder
